import React from 'react';
import styles from '../../styles/Contact.module.scss';
import { content } from '../../utils/contact';

const Contact = () => {
  return (
    <div className={styles.container}>
      <div className={styles.insideContainer}>
        <p className={styles.contactHeader}>Kontakt</p>
      </div>
      <div className={styles.row}>
        <div className={styles.insideContainer}>
          <p className={styles.insideHeader}>
            Redakcja programu lokalnego TV TOYA:
          </p>
          <p className={styles.insideText}>ul. Łąkowa 29 B, 90-554 Łódź</p>
          <p className={styles.insideText}>
            tel.: 42 643-94-93 <br /> fax. 42-643-94-05
          </p>
          <p className={styles.email}>redakcja@toya.com.pl</p>
        </div>
        <div className={styles.insideContainer}>
          <p className={styles.insideHeader}>Serwis informacyjny</p>
          <p className={styles.insideText}>
            tel. 42-643-99-16 <br /> fax. 42-643-94-05
            <br />
          </p>
          <p className={styles.email}>wydarzenia@toya.com.pl</p>
        </div>

        <div className={styles.insideContainer}>
          <p className={styles.insideHeader}>
            Telefon w czasie trwania programu na żywo:
          </p>
          <span className={styles.bigger}>42 649-48-28</span>
        </div>
      </div>
      <div className={styles.emailsContainer}>
        {content.map((el, idx) => (
          <div className={styles.insideContainer} key={'contact' + idx}>
            <p className={styles.insideHeader}>{el.header}</p>
            <p className={styles.emailSecondary}>{el.email}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Contact;
